import { NgModule } from '@angular/core';
import { TrackNavigationDirective } from './track-navigation.directive';

@NgModule({
  declarations: [TrackNavigationDirective],
  exports: [TrackNavigationDirective],
})
export class TrackNavigationModule {}
